import { ref } from '#imports';

export function useLayoutSpinner() {
  const isSpinnerVisible = ref(false);

  const showSpinner = () => {
    isSpinnerVisible.value = true;
  };

  const hideSpinner = () => {
    isSpinnerVisible.value = false;
  };

  return { isSpinnerVisible, showSpinner, hideSpinner };
}
